export const setLinks = () => {
  return {
    linkToHomepage: "/",
    linkToFaq: "/faqs",
    linkToLogin: process.env.GATSBY_LOGIN_URL,
  }
}
